<template>
<el-container >
  <el-header style="padding:0" height="114.78px">
    <Header :teleNum="teleNum"></Header>
  </el-header>
  <el-container>
    <el-aside>
      <Leftnav :menuList="menu" />
    </el-aside>
    <el-main >
      <router-view></router-view>
    </el-main>
  </el-container>
</el-container>
</template>
<style>

</style>

<script>

import Header from "../../components/common/header.vue"
import Leftnav from "../../components/common/menu.vue"

export default {
  name: "client",
  props: {
  },
  components: {
    Header,
    Leftnav,
  },
  data() {
    return {
      // showclass: 'asideshow',
      // menu: this.$store.state.currentMenu,
      // teleNum:  this.$store.state.userId
    }
  },
  computed:{
    menu() {
      if(this.$store.state.currentMenu == ""){
        return JSON.parse(sessionStorage.getItem("currentMenu"))
      }
      return this.$store.state.currentMenu
    },
    teleNum() {
      if(this.$store.state.teleNum == ""){
        return sessionStorage.getItem("teleNum")
      }
      return this.$store.state.teleNum
    }
  }
};
</script>
<style>
/* body {
  background: white !important;
} */
</style>
<style scoped>
  aside{
    width:255px !important;
  }
</style>